import { APP_NAME } from "@/lib/constants";

export function MobileHeader() {
  return (
    <header className="flex md:hidden items-center justify-center border-b border-border bg-background px-4 py-3">
      <h1 className="text-lg font-[family-name:var(--font-heading)] text-foreground">
        {APP_NAME}
      </h1>
    </header>
  );
}
